import { jsx } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import { Box, ChatHeader } from "pcln-design-system";
import PennyToolTip from "./PennyToolTip.js";
const DefaultModalHeader = (props)=>{
    const modalHeaderRef = useRef(null);
    useEffect(()=>{
        if (props.onDefaultModalHeaderRendered) props.onDefaultModalHeaderRendered();
    }, []);
    useEffect(()=>{
        modalHeaderRef.current.querySelectorAll('button')[1].style.display = 'none';
    }, [
        props.speechEnabled
    ]);
    return /*#__PURE__*/ jsx(Box, {
        ref: modalHeaderRef,
        "data-testid": "chat-header-box",
        children: /*#__PURE__*/ jsx(ChatHeader, {
            onClose: props.onClose,
            onMinimize: props.onClose,
            children: /*#__PURE__*/ jsx(PennyToolTip, {})
        })
    });
};
export { DefaultModalHeader };
